import React from 'react'

const Logo = () => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 170.88 30.03"
  >
    <defs></defs>
    <title>Untitled-3</title>
    <path
      className="cls-1 talk_part_logo"
      d="M38,14.7c0-5.47-1.18-8.47-7.12-8.47H22.32l-1.69,4.36H29c3.23,0,3.76.93,3.77,4.63H24.53c-3.94,0-6.2,2.52-6.2,6.94,0,4.24,2.57,7.26,6.25,7.26H38Zm-5.14,4.88v5.48H25.4c-1.49,0-2.17-1.35-2.18-2.7a2.94,2.94,0,0,1,.8-2.09,2.29,2.29,0,0,1,1.65-.69Z"
    />
    <path
      className="cls-2 more_part_logo"
      d="M170.39,11.73a7.47,7.47,0,0,0-5.3-5.57,15.58,15.58,0,0,0-8.46-.07,7.79,7.79,0,0,0-5.93,6.31,35.77,35.77,0,0,0-.52,6.73h0c0,7.49,2.13,10.3,7.12,10.3h11.38L167,25.06h-8.7a2.7,2.7,0,0,1-2.05-.72c-1-1-.92-3-.92-3.9v-.22h15.54V20C170.85,19.77,171,14.2,170.39,11.73Zm-12.57-1.54a7.06,7.06,0,0,1,5.56,0c1.61.76,2.49,2.6,2.49,5.68H155.33C155.33,12.77,156.15,10.94,157.82,10.19Z"
    />
    <path
      className="cls-1 talk_part_logo"
      d="M15.64,24.43l-.81.23a12.57,12.57,0,0,1-4,.4A3,3,0,0,1,7.74,22.2a10.51,10.51,0,0,1-.11-1.33c0-3.05,0-9.24,0-9.24v-1h6.31l1.7-4.36h-8V0H2.51V6.23H0v4.36H2.51v9.89a22.32,22.32,0,0,0,.18,2.89c.39,3,1.71,4.89,4,5.82a11.58,11.58,0,0,0,3.08.69,14.55,14.55,0,0,0,1.46.07,13.43,13.43,0,0,0,4.26-.69l.11,0Z"
    />
    <path
      className="cls-2 more_part_logo"
      d="M108.22,14.78a15,15,0,0,0-.15-2.39c-.44-2.84-1.68-4.69-3.78-5.68a12.55,12.55,0,0,0-9.43-.48A6.12,6.12,0,0,0,91.7,8.78a6.56,6.56,0,0,0-4.72-3A14.88,14.88,0,0,0,81,6l-5.8,1.18v22.2h5.09s0-10.93,0-14.2a14.6,14.6,0,0,1,.16-2.09,2.79,2.79,0,0,1,2.24-2.52,8.71,8.71,0,0,1,4,0,2.88,2.88,0,0,1,2.38,2.69,16.26,16.26,0,0,1,.12,2.09V29.42h5V15.51s0-1.18,0-1.6c.12-1.93.92-3,2.59-3.36a8.23,8.23,0,0,1,3.79,0A2.86,2.86,0,0,1,103,13.28a17.93,17.93,0,0,1,.13,2c0,3.29,0,14.14,0,14.14h5.08S108.24,18.26,108.22,14.78Z"
    />
    <rect className="cls-1 talk_part_logo" x="42.73" width="5.04" height="29.42" />
    <path
      className="cls-2 more_part_logo"
      d="M148.69,5.9a12.93,12.93,0,0,0-6.25,0l-5.6,1.28v22.2h5.08s0-11.33,0-14.74a11.48,11.48,0,0,1,.18-2.07,2.45,2.45,0,0,1,2.19-2.12,11.13,11.13,0,0,1,2.24-.09,11.93,11.93,0,0,1,1.42.17l.87.17V5.93Z"
    />
    <polygon
      className="cls-1 talk_part_logo"
      points="73.09 29.42 62.73 17.73 71.53 7.22 65.15 7.22 57.5 16.56 57.5 0 52.55 0 52.55 29.42 57.5 29.42 57.5 19.16 66.72 29.42 73.09 29.42"
    />
    <path
      className="cls-2 more_part_logo"
      d="M133.14,13.83c-.32-4.29-3-7.19-7.44-8a16.31,16.31,0,0,0-6.43,0c-4.41.78-7.12,3.68-7.43,8a52.55,52.55,0,0,0,0,8.23,7.7,7.7,0,0,0,5.58,7.19,16,16,0,0,0,4.94.78h.22a16.09,16.09,0,0,0,4.94-.78,7.71,7.71,0,0,0,5.57-7.19A53.79,53.79,0,0,0,133.14,13.83ZM128,21.48a3.41,3.41,0,0,1-3.13,3.39,18.93,18.93,0,0,1-2.41.2,18.78,18.78,0,0,1-2.41-.2,3.41,3.41,0,0,1-3.14-3.39,64.84,64.84,0,0,1,0-7.09c.13-2.28,1.14-3.4,3.48-3.85a11.65,11.65,0,0,1,2.1-.2,11.46,11.46,0,0,1,2.09.2c2.34.45,3.35,1.57,3.48,3.85A64.84,64.84,0,0,1,128,21.48Z"
    />
  </svg>
)

export default Logo
